











import { Component, Prop, Vue } from 'vue-property-decorator';
import { CommandVar } from '../../cablin/commands';
import ValueComp from '../value/Value.vue';

@Component({
  components: {
    ValueComp,
  }
})
export default class CommandVarComp extends Vue {
  @Prop() private cmd!: CommandVar
}
